import React from 'react'
import './about.css'
import {motion} from 'framer-motion/dist/framer-motion'
import {options} from '../../Components/options'

function About() {
    return (
        <motion.div
        initial={options.initial}
        animate={options.animate}
        exit={options.exit}
        onAnimationComplete={() => { window.scrollTo(0,0)}}
        className="row_1_pages aboutContainer"
        >
            <div className="col_1_pages aboutContainer__left">
                <h2>Me Myself, And I</h2>

                <p> 
                    Having a natural curiosty for the world. Along with the passion
                    for learning. Is my core of <span className="tag">me</span>. From my work Ethics, lifestyle, 
                    and carrer. To my passion, hardwork, and determination. With having a curious mind i have always 
                    been hard on myself. When i failed to understand questions/topics/ect. Which is both a weakness and strength. 
                    While having a passion for learning with an inquisitive mind. Can be a useful or helpful to have in my field. 
                    I take it to extreme measures. If i failed to understand a problem my inquisitive mind turns to fustration and cloudy. 
                    However, i have been taking steps, through the use of research. To find a solution to my problems. The first step was to 
                    analyze the problem. Now i am working on improving myself to be a better Application Developer.
                    <br/> <br/>
                    Through my earliest childhood i knew where my curisoty will take me. To technology. 
                    Since i have always been fascinated how computers work. along with their applications 
                    in the real world. to build something from nothing. Drives me to learn. develop and 
                    deploy new applications.  
                    <br/><br/> 
                    My carrer has not really started until i atteneded STC.
                    Where my passions was finally realized. With my goal in mind along with the determination. To 
                    design, code, and build real applications.
                    <br/><br/>
                    Over the years i have picked up interests such as Criminology, Psychology, Aquaponics, Technologies and more. When i am relaxing i 
                    play Video Games with friends. Watching Technologies, and serial killers documentaries. Which both are my top favorite among many others.
                    aquascaping with my fish tanks, i am an avid fish keeper. Playing my Classical Guitar helps me relax to enjoy the melodies produced uniqued
                    to the Classical Guitar.
                </p>
            </div>

            <div className="col_1_pages aboutContainer__right">
                <div className="aboutContainer__wrapper">
                    <div className="rotate">
                    <h2>Shrimp Keeping</h2>
                    </div>
                    <div className="rotate">
                    <h2>Learning</h2>
                    </div>
                    <div className="rotate">
                    <h2>Technology</h2>
                    </div>
                    <div className="rotate">
                    <h2>Aquaponics</h2>
                    </div>
                    <div className="rotate">
                    <h2>Playing Guitar</h2>
                    </div>
                    <div className="rotate">
                    <h2>Listening to music</h2>
                    </div>
                    <div className="rotate">
                    <h2>Reading</h2>
                    </div>
                    <div className="rotate">
                    <h2>Designing</h2>
                    </div>
                </div>


            </div>
        </motion.div>
    )
}

export default About
